export default __webpack_public_path__ + "static/media/patient_name.86827204.svg";